import { render } from "./NuevaCompra.vue?vue&type=template&id=77802fca&scoped=true"
import script from "./NuevaCompra.vue?vue&type=script&lang=js"
export * from "./NuevaCompra.vue?vue&type=script&lang=js"

import "./NuevaCompra.vue?vue&type=style&index=0&id=77802fca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77802fca"]])

export default __exports__